const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/patAppointmentsReducer.ts';
import Imm from 'immutable';
import { Logger } from '../services/KisLoggerService';
import { decCounter, incCounter } from '../utils/reducerUtils';
import {
    actionTypes,
    ForgetStructuredAppointmentsForPatientAction,
    LoadAppointmentRecordAction,
    LoadStructuredAppointmentsForPatientAction,
} from '../actions/patAppointmentsActions';
import { IActionHandlersMap, IKisApiHandlersMap, makeReducer } from '../defs/actionTypes';

const Log = Logger('patAppointmentsReducer');

const loadAppointmentRecordHandlers: IKisApiHandlersMap<LoadAppointmentRecordAction> = {
    pending: state => {
        return incCounter(state, ['loading']);
    },
    success: (state, action) => {
        const rec = Imm.fromJS(action.payload || {});
        state = state.setIn(['records', action.meta.termnr], rec);
        return decCounter(state, ['loading']);
    },
    failure: (state, action) => {
        Log.error(`Failed to load appointment: ${action.meta.termnr}`);
        return decCounter(state, ['loading']);
    },
};

const loadStructuredAppointmentsForPatientHandlers: IKisApiHandlersMap<LoadStructuredAppointmentsForPatientAction> = {
    pending: state => {
        return incCounter(state, ['loading']);
    },
    success: (state, action) => {
        const payload = Imm.fromJS(action.payload?.List || {});

        payload.forEach((rec: Imm.Map<string, any>) => {
            const termnr = rec.get('TERMNR');
            if (!termnr) {
                Log.error('Record with missing TERMNR!', rec.toJS());
            } else {
                const stateContent = state.getIn(['records', termnr, 'CONTENT']);

                state = state.setIn(['records', termnr], rec);
                state = state.setIn(['records', termnr, 'CONTENT'], rec.get('CONTENT') ?? stateContent);
            }
        });

        return decCounter(state, ['loading']);
    },
    failure: state => {
        Log.warn(`Failed to load appointments for patient`);
        return decCounter(state, ['loading']);
    },
};

const handlers: IActionHandlersMap = {
    [actionTypes.loadAppointmentRecord.pending]: loadAppointmentRecordHandlers.pending,
    [actionTypes.loadAppointmentRecord.success]: loadAppointmentRecordHandlers.success,
    [actionTypes.loadAppointmentRecord.failure]: loadAppointmentRecordHandlers.failure,

    [actionTypes.loadStructuredAppointmentsForPatient.pending]: loadStructuredAppointmentsForPatientHandlers.pending,
    [actionTypes.loadStructuredAppointmentsForPatient.success]: loadStructuredAppointmentsForPatientHandlers.success,
    [actionTypes.loadStructuredAppointmentsForPatient.failure]: loadStructuredAppointmentsForPatientHandlers.failure,

    [actionTypes.forgetStructuredAppointmentsForPatient]: (
        state,
        _action: ForgetStructuredAppointmentsForPatientAction
    ) => {
        return state.deleteIn(['records']);
    },
};

export const initialState = Imm.fromJS({
    loading: 0,
    records: {
        // Maps termnr -> record data
    },
});

export const patAppointmentsReducer = makeReducer(handlers, initialState);
